import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringOrDashes'
})
export class StringOrDashesPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value !== undefined
      && value !== null
      && value !== '') {
      return value;
    }
    return '--';
  }

}
